import { _endpointHoliday } from "../../utils/provider";
import { _createRequest, _getFilter, _pick, _fetch } from "../../utils/helper";
import { USER_GROUP_OWNER_AGENCY } from "../../utils/const";

const endpoint = async (props) => {
    const { type, user = {} } = props;
    let params = JSON.parse(JSON.stringify(props.params || {}));

    if (user.group === USER_GROUP_OWNER_AGENCY) {
        // if (params.filter) params.filter.agency_id = user.agency_id;
        // if (params.data) params.data.agency_id = user.agency_id;
    }

    if (params.data && params.data.cooldown_hours) {
        params.data.cooldown_duration_sec = params.data.cooldown_hours * 3600;
    }

    switch (type) {
        case "create": {
            return _fetch(
                _createRequest(_endpointHoliday.create, true, _pick(params.data, [
                    "date",
                    "messages",
                ]))
            );
        }
        case "update": {
            return _fetch(
                _createRequest(_endpointHoliday.update, true, _pick(params.data, [
                    "id",
                    "date",
                    "messages",
                ]))
            ).then((res) => {
                return {
                    data: params.id,
                };
            });
        }
        case "delete": {
            return _fetch(
                _createRequest(_endpointHoliday.delete, true, {
                    ..._pick(params, ["id"]),
                })
            ).then((res) => {
                return {
                    data: params.id,
                };
            });
        }
        default: {
            //list
            return _fetch(
                _createRequest(_endpointHoliday.list, true, {
                    filter: `${_getFilter(params, {})}`,
                })
            ).then((res) => {
                let data = res.data.map((item) => {
                    return {
                        ...item,
                        cooldown_hours: item.cooldown_duration_sec / 3600,
                    };
                })
                return {
                    data: data,
                    total: res.total,
                };
            })
        }
    }
};

export default endpoint;
